import { State } from "@fitness-force/models";

export const CONST_STATES: State[] = [
    { "id": 1, "name": "Maharashtra", "country_code": "IND", "country_id": 101, "code": "MH" },
    { "id": 2, "name": "Delhi", "country_code": "IND", "country_id": 101, "code": "DL" }
];